type Env = 'local' | 'nightly' | 'staging' | 'testnet' | 'prod';

type Flag =
  | 'account-usernames-enabled'
  | 'localization-enabled'
  | 'order_book-100ms-snapshots-enabled';

const FEATURE_FLAGS: Record<Flag, Record<Env, unknown>> = {
  'account-usernames-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: false,
    prod: false,
  },
  'localization-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: false,
    prod: false,
  },
  'order_book-100ms-snapshots-enabled': {
    local: false,
    nightly: false,
    staging: false,
    testnet: false,
    prod: false,
  },
};

const FeatureFlags = {
  getBooleanValue(flag: Flag, defaultValue: boolean): boolean {
    return Boolean(getValue(flag, defaultValue));
  },
};

function getValue(flag: Flag, defaultValue: unknown): unknown {
  if (IS_RUNNING_IN_CYPRESS === 'true') return true;
  if (ENVIRONMENT === 'test-runner') return true;
  if (String(FE_DOMAIN).includes('localhost')) return FEATURE_FLAGS[flag].local;
  return FEATURE_FLAGS[flag][ENVIRONMENT as Env] ?? defaultValue;
}

export { FeatureFlags };
